var getProp = { exports: {} };
export {
  getProp as __module
};
//# sourceMappingURL=getProp.js.map
